<div class="expanding-drawer-container">
  <div class="click-area" (click)="handleExpand(!isOpen)">
    <div class="expanding-drawer-header" [ngClass]="{ 'open': isOpen }">
      <div class="carat">
        <i class="material-icons">keyboard_arrow_right</i>
      </div>
      <div class="title">
        <h3>{{ title }}</h3>
      </div>

      <div class="right-content">
        <div class="badge" *ngIf="badge">
          <span class="klabel-small label">{{ badge }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="expanding-drawer-content" [style]="{ maxHeight: maxDrawerHeight }">
    <div class="fixed-header">
      <div class="header">
        <ng-content select="[fixed-header]">
        </ng-content>
      </div>
    </div>

    <div class="scroll-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>